
import React from "react";
import format from "../../../helpers/format";

const ResourceStatusChart = ({ data }) => (
  <div className="chart-block p-3 p-md-4 shadow rounded-4" style={{ minHeight: "350px", height: "100%" }}>
    <p className="mb-4"><strong>Resources by Status</strong></p>
    {data.length > 0 ? (
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th className="text-uppercase small">Status</th>
              <th className="text-uppercase small">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.map((entry, idx) => (
              <tr key={idx}>
                <td className="text-uppercase">{entry.Name && format.formatResourceStatus(entry.Name)}</td>
                <td className="small">{entry.Total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-muted">No data available for the table.</p>
    )}
  </div>
);

export default ResourceStatusChart;
